import { EnterExitDailyRecord } from './EnterExitDailyRecord';

export class EnterExitHourlyRecord extends EnterExitDailyRecord {
    time!: string;
    isworkingtime!: boolean;
}
